(function($) {

}( jQuery ));



function updateColor() {

	$('#js-color-select').on('change', function(){
			// console.log($(this).val());
			$('#logo_color').val($(this).val());
		});
}

function checkMinQuantity(){

		var total = 0;
		var qty = 0;
		$('.js-quantity').each(function(){
			$this = $(this);
			if ($this.val() == 0){
				qty = 0;
			} else {
				qty = parseInt($this.val());
			}
			total += qty;
		});
		console.log(total);
		if (total > 0){
			return true
		}
		return false
}



$(function(){

	if ($('#js-configurator-products').length) {
		updateColor();
	}

});